'use client';

import {
  KanbanBoard,
  KanbanCard,
  KanbanCards,
  KanbanHeader,
} from '@/components/ui/shadcn-io/kanban';
import { format} from 'date-fns';
import { useGetList } from 'react-admin';

import CommonKanban from '@/components/common/Kanban';
import { Reservation } from '@/interface/entityInterface';

const exampleStatuses = [
  { id: '1', name: 'PENDING', color: '#6B7280' },
  { id: '2', name: 'IN PROGRESS', color: '#F59E0B' }, 
  { id: '3', name: 'FINISHED', color: '#10B981' },
];

const ReservationKanban = () => {
  const {data = []} = useGetList("auto-service-reservation")

  return (
    <CommonKanban statuses={exampleStatuses} resource='auto-service-reservation'>
        {exampleStatuses.map((status) => (
        <KanbanBoard key={status.name} id={status.name}>
          <KanbanHeader name={status.name} color={status.color} />
          <KanbanCards>
            {data.length > 0 && data
              .filter((feature: Reservation) => feature.status === status.name)
              .map((feature: Reservation, index) => (
                <KanbanCard
                  key={feature.id}
                  id={"" + feature.id}
                  name={feature.guest_user.name}
                  parent={status.name}
                  index={index}
                >
                  <div className="flex items-start justify-between gap-2">
                    <div className="flex flex-col gap-1">
                      <p className="m-0 flex-1 font-medium text-sm">
                        {feature.guest_user.name}
                      </p>
                      <p className="m-0 text-muted-foreground text-xs">
                        {feature.branches.name}
                      </p>
                    </div>
                    <p className="m-0 font-medium text-sm overflow-hidden text-clip">
                      {feature.guest_vehicle.license_plate}
                    </p>
                  </div>
                  <p className="m-0 text-muted-foreground text-xs">
                    {format(feature.date, "yyyy-MM-dd HH:mm ")}
                  </p>
                </KanbanCard>
              ))}
          </KanbanCards>
        </KanbanBoard>
      ))}
    </CommonKanban>
  );
};

export default ReservationKanban;